import { jsx as _jsx } from "react/jsx-runtime";
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Plugin, PluginKey } from '@tiptap/pm/state';
const PlaceholderChipComponent = ({ node }) => {
    return (_jsx(NodeViewWrapper, { className: "inline", as: "span", children: _jsx("span", { className: "inline-block rounded bg-primary/5 px-1.5 py-0.5 font-mono text-xs text-primary border border-primary/20 dark:bg-primary/15 dark:border-primary/30", contentEditable: false, children: `{{${node.attrs.key}}}` }) }));
};
const PLACEHOLDER_TEXT_RE = /\{\{([\w.]+)\}\}/g;
const placeholderChipPluginKey = new PluginKey('placeholderChipConvert');
function convertTextToChips(editor) {
    const { doc, tr } = editor.state;
    const chipType = editor.schema.nodes.placeholderChip;
    if (!chipType)
        return;
    let modified = false;
    const replacements = [];
    doc.descendants((node, pos) => {
        if (!node.isText || !node.text)
            return;
        let match;
        PLACEHOLDER_TEXT_RE.lastIndex = 0;
        while ((match = PLACEHOLDER_TEXT_RE.exec(node.text)) !== null) {
            replacements.push({
                from: pos + match.index,
                to: pos + match.index + match[0].length,
                key: match[1],
            });
        }
    });
    for (let i = replacements.length - 1; i >= 0; i--) {
        const r = replacements[i];
        tr.replaceWith(r.from, r.to, chipType.create({ key: r.key }));
        modified = true;
    }
    if (modified) {
        tr.setMeta(placeholderChipPluginKey, true);
        editor.view.dispatch(tr);
    }
}
export const PlaceholderChip = Node.create({
    name: 'placeholderChip',
    group: 'inline',
    inline: true,
    atom: true,
    selectable: true,
    addAttributes() {
        return {
            key: { default: '' },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-placeholder-chip]',
                getAttrs: (dom) => {
                    const el = dom;
                    return { key: el.getAttribute('data-placeholder-chip') };
                },
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return [
            'span',
            mergeAttributes(HTMLAttributes, { 'data-placeholder-chip': node.attrs.key }),
            `{{${node.attrs.key}}}`,
        ];
    },
    addNodeView() {
        return ReactNodeViewRenderer(PlaceholderChipComponent);
    },
    addProseMirrorPlugins() {
        const editorRef = this.editor;
        return [
            new Plugin({
                key: placeholderChipPluginKey,
                appendTransaction(_transactions, _oldState, newState) {
                    let hasText = false;
                    newState.doc.descendants((node) => {
                        if (hasText)
                            return false;
                        if (node.isText && node.text && PLACEHOLDER_TEXT_RE.test(node.text)) {
                            hasText = true;
                            return false;
                        }
                    });
                    if (!hasText)
                        return null;
                    // Defer to next microtask to avoid dispatch-in-dispatch
                    queueMicrotask(() => convertTextToChips(editorRef));
                    return null;
                },
            }),
        ];
    },
});
//# sourceMappingURL=PlaceholderChip.js.map